<!-- Toolbar for sidenav -->
<mat-toolbar class="viewer-toolbar">
  <span>{{ title }}</span>
  <span class="spacer"></span>
  
  @if (document) {
    <button mat-icon-button 
            (click)="download.emit()"
            matTooltip="Download">
      <mat-icon>download</mat-icon>
    </button>
    
    <button mat-icon-button 
            (click)="openNewTab.emit()"
            matTooltip="Open in new tab">
      <mat-icon>open_in_new</mat-icon>
    </button>
  }
  
  <button mat-icon-button (click)="close.emit()">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<!-- Viewer content -->
<div class="viewer-content">
  @if (document) {
    @if (document.previewUnavailable) {
      <!-- Office document that can't be previewed (blob URL or private S3) -->
      <div class="preview-unavailable-notice">
        <div class="notice-banner">
          <mat-icon class="notice-icon">info</mat-icon>
          <div class="notice-text">
            <span class="notice-title">{{ document.previewUnavailableReason || 'Preview not available' }}</span>
            <span class="notice-subtitle">{{ document.fileType.toUpperCase() }} file</span>
          </div>
        </div>
        <div class="file-placeholder">
          <mat-icon class="large-icon">description</mat-icon>
          <p class="file-name">{{ document.fileName }}</p>
          <div class="file-actions">
            <button mat-raised-button
                    color="primary"
                    (click)="download.emit()">
              <mat-icon>download</mat-icon>
              Download to View
            </button>
            <button mat-stroked-button
                    (click)="openNewTab.emit()">
              <mat-icon>open_in_new</mat-icon>
              Open in New Tab
            </button>
          </div>
        </div>
      </div>
    } @else if (document.isPdf || document.isImage || document.isOfficeDocument) {
      <iframe [src]="document.safeViewerUrl"
              width="100%"
              height="100%"
              frameborder="0"
              [title]="document.fileName"
              class="document-iframe">
      </iframe>
    } @else {
      <div class="unsupported-file">
        <mat-icon class="large-icon">description</mat-icon>
        <p class="file-name">{{ document.fileName }}</p>
        <p class="file-info">Preview not available for this file type</p>
        <button mat-raised-button
                color="primary"
                (click)="openNewTab.emit()">
          <mat-icon>open_in_new</mat-icon>
          Open in New Tab
        </button>
        <button mat-stroked-button
                (click)="download.emit()">
          <mat-icon>download</mat-icon>
          Download
        </button>
      </div>
    }
  } @else {
    <div class="no-file-placeholder">
      <mat-icon class="large-icon">insert_drive_file</mat-icon>
      <p>No document loaded</p>
    </div>
  }
</div>